module.exports = __webpack_public_path__ + "assets/img/IMG019.9b328c19.png";